import { svg } from "lit";

export const spinnerGradient = svg`
  <g id="Spinner">
    <path id="Spinner part" d="M7 1.00003C3.68629 1.00003 1 3.68632 1 7.00003C1 10.3137 3.68629 13 7 13C7.94137 13 8.8321 12.7832 9.625 12.3969" stroke="url(#paint0_radial_19833_411)" stroke-width="1.3" stroke-linecap="round"/>
    <path id="Spinner part_2" d="M13 7.00003C13 3.68632 10.3137 1.00003 7 1.00003C3.68629 1.00003 1 3.68632 1 7.00003C1 8.71593 1.72029 10.2636 2.875 11.3572" stroke="url(#paint1_radial_19833_411)" stroke-width="1.3" stroke-linecap="round"/>
  </g>
  <defs>
    <radialGradient id="paint0_radial_19833_411" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.125 11.625) rotate(2.24575) scale(6.3799)">
      <stop stop-color="#00B050"/>
      <stop offset="0.812835" stop-color="#00B050" stop-opacity="0"/>
    </radialGradient>
    <radialGradient id="paint1_radial_19833_411" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.6562 5.10419) rotate(158.924) scale(12.224)">
      <stop stop-color="#5BB3EA" stop-opacity="0"/>
      <stop offset="0.328125" stop-color="#108AD6"/>
      <stop offset="0.682292" stop-color="#00B050"/>
    </radialGradient>
  </defs>
`;
